var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"class-list"},[_c('GlobalInfoBar',{attrs:{"title":"问答配置","content":"配置门店端小程序或H5页面问答展示信息"}}),_c('GlobalChunkNo',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('From',{attrs:{"option":_vm.typeOptions}})],1),_c('Table',{attrs:{"option":_vm.typeOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }